import { Injectable } from '@angular/core';
import { HttpHeaders, HttpResponse } from '@angular/common/http';

@Injectable({
    providedIn: 'root',
})
export class DownloadService {

    triggerDownload(response: HttpResponse<Blob>, defaultFileName: string = 'file.dat'): string {
        const filename = this.extractFilename(response.headers.get('Content-Disposition'), defaultFileName);

        if (response.body) {
            const a = document.createElement('a');
            const objectUrl = URL.createObjectURL(response.body);
        
            a.href = objectUrl;
            a.download = filename;
            a.style.display = 'none';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
        
            URL.revokeObjectURL(objectUrl);
            return filename;
        } else {
            throw new Error('Empty response body');
        }
    }

    private extractFilename(contentDisposition: string | null, fallback: string): string {
        if (!contentDisposition) return fallback;

        const utf8FilenameRegex = /filename\*=UTF-8''([\w%\-\.]+)(?:; ?|$)/i;
        const utf8Match = utf8FilenameRegex.exec(contentDisposition);
        if (utf8Match && utf8Match[1]) {
            return decodeURIComponent(utf8Match[1]);
        }

        const asciiFilenameRegex = /filename=(["']?)(.*?[^\\])\1(?:; ?|$)/i;
        const asciiMatch = asciiFilenameRegex.exec(contentDisposition);
        if (asciiMatch && asciiMatch[2]) {
            return asciiMatch[2].trim();
        }

        return fallback;
    }

    download(response: HttpResponse<Blob>, filename?: string): void {
        this.triggerDownload(response, (filename ?? 'file.dat'));
    }

    createHttpResponseBlobFromText(text: string, mimeType: string, httpHeaders?: {[name: string]: string | number | (string | number)[]}): HttpResponse<Blob>{
        const blob = new Blob([text], { type: mimeType });
        const response = new HttpResponse({
            body: blob,
            status: 200,
            statusText: 'OK',
            headers: new HttpHeaders({
                'Content-Type': mimeType,
                ...httpHeaders,
            }),
            url: 'http://mock-url' // Opcionális
        });
        return response;
    }
}
